var _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.56 0.56 51.89 51.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26.5536,
    rx: 25.5,
    ry: 25.5536,
    fill: "#F7F7F7",
    fillOpacity: 0.1,
    stroke: "#54BA4A",
    strokeWidth: 0.8875
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.4999,
    cy: 26.5533,
    rx: 22.6132,
    ry: 22.6607,
    fill: "#54BA4A",
    fillOpacity: 0.22
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_14360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5685 19.042C27.3807 19.042 28.1596 19.38 28.7339 19.9817C29.3082 20.5834 29.6308 21.3994 29.6308 22.2503C29.6308 23.1012 29.3082 23.9173 28.7339 24.519C28.1596 25.1206 27.3807 25.4587 26.5685 25.4587C25.7564 25.4587 24.9775 25.1206 24.4032 24.519C23.8289 23.9173 23.5063 23.1012 23.5063 22.2503C23.5063 21.3994 23.8289 20.5834 24.4032 19.9817C24.9775 19.38 25.7564 19.042 26.5685 19.042ZM20.444 21.3337C20.934 21.3337 21.3889 21.4712 21.7826 21.7187C21.6514 23.0295 22.0189 24.3312 22.7713 25.3487C22.3339 26.2287 21.4589 26.8337 20.444 26.8337C19.7479 26.8337 19.0802 26.5439 18.588 26.0282C18.0957 25.5125 17.8192 24.813 17.8192 24.0837C17.8192 23.3543 18.0957 22.6548 18.588 22.1391C19.0802 21.6234 19.7479 21.3337 20.444 21.3337ZM32.6931 21.3337C33.3892 21.3337 34.0568 21.6234 34.5491 22.1391C35.0413 22.6548 35.3179 23.3543 35.3179 24.0837C35.3179 24.813 35.0413 25.5125 34.5491 26.0282C34.0568 26.5439 33.3892 26.8337 32.6931 26.8337C31.6781 26.8337 30.8032 26.2287 30.3657 25.3487C31.1286 24.3169 31.4827 23.0168 31.3544 21.7187C31.7481 21.4712 32.2031 21.3337 32.6931 21.3337ZM20.8815 30.7295C20.8815 28.832 23.4275 27.292 26.5685 27.292C29.7095 27.292 32.2556 28.832 32.2556 30.7295V32.3337H20.8815V30.7295ZM16.0693 32.3337V30.9587C16.0693 29.6845 17.723 28.612 19.9628 28.3003C19.4466 28.9237 19.1316 29.7853 19.1316 30.7295V32.3337H16.0693ZM37.0677 32.3337H34.0055V30.7295C34.0055 29.7853 33.6905 28.9237 33.1743 28.3003C35.4141 28.612 37.0677 29.6845 37.0677 30.9587V32.3337Z",
    fill: "#54BA4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_14360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9984,
    height: 22,
    fill: "white",
    transform: "translate(16.0693 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.37c6fe5ff68df770318d74271988cabf.svg";
export { ForwardRef as ReactComponent };